import React from "react";
import Layout from "../Components/Layout/Layout";
import { Link } from "react-router-dom";

const Error = () => {
  return (
    <>
      <Layout>
        <>
          <div className="inner-page-banner">
            <div className="breadcrumb-vec-btm">
              <img
                className="img-fluid"
                src="assets/images/bg/inner-banner-btm-vec.png"
                alt=""
              />
            </div>
            <div className="container">
              <div className="row justify-content-center align-items-center text-center">
                <div className="col-lg-6 align-items-center">
                  <div className="banner-content">
                    <h1>Error</h1>
                    <nav aria-label="breadcrumb">
                      <ol className="breadcrumb">
                        <li className="breadcrumb-item">
                          <Link to={'/'}>Home</Link>
                        </li>
                        <li
                          className="breadcrumb-item active"
                          aria-current="page"
                        >
                          Error
                        </li>
                      </ol>
                    </nav>
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="banner-img d-lg-block d-none">
                    <div className="banner-img-bg">
                      <img
                        className="img-fluid"
                        src="assets/images/bg/inner-banner-vec.png"
                        alt=""
                      />
                    </div>
                    <img
                      className="img-fluid"
                      src="assets/images/bg/inner-banner-img.png"
                      alt=""
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="error-page mb-120">
            <div className="container">
              <div className="row">
                <div className="col-lg-12">
                  <div className="error-wrapper">
                    <div className="error-img">
                      <img
                        className="img-fluid"
                        src="assets/images/bg/error-img.png"
                        alt=""
                      />
                    </div>
                  </div>
                  <div className="error-content-area">
                    <h2>Something Went Wrong</h2>
                    <p>
                      Donec bibendum enim ut elit porta ullamcorper. Vestibulum
                      Nai quam nulla, venenatis eget dapibus ac, catali topuny
                      wekemdini iaculis vitae nulla. Morbi mattis nec mi ac
                      mollis.{" "}
                    </p>
                    <div className="error-btn">
                      <Link className="primary-btn1" to={'/'}>
                        <img src="assets/images/icon/home-icon.svg" alt="" />{" "}
                        Back to home
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      </Layout>
    </>
  );
};

export default Error;
